import React, { useState, useEffect } from 'react';
import api from '../services/api';

const VehicleDataDebugger = () => {
  const [vehicles, setVehicles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [apiResponse, setApiResponse] = useState(null);

  useEffect(() => {
    const fetchVehicles = async () => {
      try {
        setLoading(true);
        // Ensure we're using the correct API endpoint according to the system configuration
        const response = await api.get('/api/v1/admin/vehicles');
        setApiResponse(response.data);
        
        // Extract vehicles based on the API response structure
        let extractedVehicles = [];
        if (response.data && response.data.success) {
          if (response.data.data && Array.isArray(response.data.data)) {
            // If data is directly an array of vehicles
            extractedVehicles = response.data.data;
          } else if (response.data.data && response.data.data.data && Array.isArray(response.data.data.data)) {
            // If data has a nested data array (pagination structure)
            extractedVehicles = response.data.data.data;
          }
        }
        
        setVehicles(extractedVehicles);
      } catch (err) {
        console.error('Error fetching vehicles:', err);
        setError(err.message || 'Failed to fetch vehicles');
      } finally {
        setLoading(false);
      }
    };

    fetchVehicles();
  }, []);

  return (
    <div className="container mx-auto p-4">
      <h1 className="text-2xl font-bold mb-4">Vehicle Data Debugger</h1>
      
      {loading ? (
        <div className="text-center p-4">Loading vehicles data...</div>
      ) : error ? (
        <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4">
          <p className="font-bold">Error:</p>
          <p>{error}</p>
        </div>
      ) : (
        <div>
          <div className="bg-white shadow-md rounded p-4 mb-4">
            <h2 className="text-xl font-semibold mb-2">API Response Structure</h2>
            <pre className="bg-gray-100 p-4 rounded overflow-x-auto text-xs">
              {JSON.stringify(apiResponse, null, 2)}
            </pre>
          </div>
          
          <div className="bg-white shadow-md rounded p-4 mb-4">
            <h2 className="text-xl font-semibold mb-2">Extracted Vehicles ({vehicles.length})</h2>
            {vehicles.length === 0 ? (
              <p className="text-gray-500">No vehicles found in the extracted data.</p>
            ) : (
              <div className="overflow-x-auto">
                <table className="min-w-full divide-y divide-gray-200">
                  <thead className="bg-gray-50">
                    <tr>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">ID</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Name</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Registration</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Type</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200">
                    {vehicles.map((vehicle) => (
                      <tr key={vehicle.id} className="hover:bg-gray-50">
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{vehicle.id}</td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{vehicle.name}</td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{vehicle.registration_number}</td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{vehicle.type}</td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                          <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${
                            vehicle.status === 'active' ? 'bg-green-100 text-green-800' : 
                            vehicle.status === 'maintenance' ? 'bg-yellow-100 text-yellow-800' : 
                            'bg-red-100 text-red-800'
                          }`}>
                            {vehicle.status}
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
          
          <div className="bg-white shadow-md rounded p-4">
            <h2 className="text-xl font-semibold mb-2">Raw Vehicle Data</h2>
            <pre className="bg-gray-100 p-4 rounded overflow-x-auto text-xs">
              {JSON.stringify(vehicles, null, 2)}
            </pre>
          </div>
        </div>
      )}
    </div>
  );
};

export default VehicleDataDebugger;
